import React from "react";
import { QrScanner } from "@yudiel/react-qr-scanner";

const QrScannerComponent = (props) => {


    return (
        <QrScanner
            onDecode={(res) => props.setQr(res)}
            onError={(err) => props.setErr(err?.message)}
        />
    )
}

export default QrScannerComponent;